module.exports = __webpack_public_path__ + "static/axo_social_mini-c3cf8e633a0417823ef347df09514468.png";